import { useCallback, useState } from 'react';

export const useBlockInstructions = () => {
  const [blockInstructions, setBlockInstructions] = useState<Record<string, boolean>>({});

  const resetBlockInstructions = useCallback(() => {
    setBlockInstructions({});
  }, []);

  const setBlocksInstructionsData = useCallback((blockInstructions: Record<string, boolean>) => {
    setBlockInstructions(blockInstructions);
  }, []);

  // Permanent delete is owned by useItemActions. This only drops the id from overlay
  // state so a later block save cannot write a deleted instruction back. Archive must
  // not call this — soft refs stay so restore reattaches and counts resolve.
  const onInstructionDelete = (instructionId: string) => {
    setBlockInstructions((instructions) => {
      const next = { ...instructions };
      delete next[instructionId];
      return next;
    });
  };

  const onInstructionCreate = (instructionId: string) => {
    setBlockInstructions((val) => ({
      ...val,
      [instructionId]: true,
    }));
  };

  const onInstructionEnabledChange = (instructionId: string, enabled: boolean) => {
    setBlockInstructions((val) => ({
      ...val,
      [instructionId]: enabled,
    }));
  };

  return {
    blockInstructions,
    onInstructionCreate,
    onInstructionDelete,
    resetBlockInstructions,
    setBlocksInstructionsData,
    onInstructionEnabledChange,
  };
};
